define('pages/app/NotificationController',[
	'jquery',
	'core/can',
	'models/Session',
	'models/Notification',
	'models/Claim',
	'models/Eligibility',
	'template!pages/app/NotificationView.stache',
	'signalr.hubs'
], function($, can, Session, Notification, Claim, Eligibility, template, $connection) {

/*
	var r = (function() {
		var id = 1;
		return function r(src) {
			if (src === undefined) {
				return ++id;
			} else if (typeof src === 'string' || src instanceof Array) {
				return src[Math.round(Math.random()*(src.length-1))];
			}
		}
	})();

	window.go = function() {
		notify([
			new ClaimNotification({
				Type: 'Axxess.RCM.Entities.Notifications.ClaimSubmissionNotification',
				Timestamp: '2015-05-08T08:00:00',
				NotificationId: r(),
				UserId: r(),
				State: r([0,1,2]),
				
				ClaimId: r(),
				TypeOfBill: r(['320','322','328','329']),
				Status: r([0,1,2,3,4,5]),
				StatusCode: r('SPRTD'),
				LocationCode: r(['B9000','B9996','B9997']),
				ReceivedDate: '2015-05-08T08:00:00',
				PatientFirstName: 'John',
				PatientLastName: 'Doe'
			}),
			new CredentialNotification({
				Type: 'Axxess.RCM.Entities.Notifications.DdeCheckNotification',
				Timestamp: '2015-05-08T08:00:00',
				NotificationId: r(),
				UserId: r(),
				State: r([0,1,2]),
				
				DdeUsername: 'TES1234',
				DdeCheckStatus: r([0,1,2])
			}),
			new EligibilityNotification({
				Type: 'Axxess.RCM.Entities.Notifications.EligibilityNotification',
				Timestamp: '2015-05-08T08:00:00',
				NotificationId: r(),
				UserId: r(),
				State: r([0,1,2]),
				
				EligibilityId: r(),
				Status: r([0,1,2,3,4,5]),
				PatientFirstName: 'John',
				PatientLastName: 'Doe',
			})
		]);
	}
*/

	return can.Control.extend({
		
		init: function(el, options) {
			
			var scope = this.scope = new can.Map({
				Notifications: new Notification.List
			});
			el.html(can.view(template, scope, {
				is: function(type, options) {
					if (this.attr('_Type') === type) {
						return options.fn(this);
					} else {
						return options.inverse(this);
					}
				}
			}));
			
/*
			window.notify = function(n) {
				scope.attr('Notifications').replace(n);
			}
			return;
*/
			$connection.hub.url = config.api_url+'/signalr';
			$connection.hub.qs = { Bearer: Session.attr('Token') };
			
			$connection.notificationHub.client.broadcastNotification = function(n) {
				var newNotificationModel = Notification.model(n);
				scope.attr('Notifications').unshift(newNotificationModel);
				
				switch(newNotificationModel.attr('_Type')) {

					case 'EligibilityNotification':
						
						if(can.route.attr('page') === 'eligibility' || (can.route.attr('page') === 'patient' && can.route.attr('id') !== undefined)) {
							Eligibility.findOne({ id: newNotificationModel.attr('EligibilityId') });
						}

						break;

					case 'DdeCheckNotification':

						if(newNotificationModel.attr('DdeCheckStatus') === 2) {
							App.event('app:credential:unverified', newNotificationModel.attr('DdeUsername'));
						}  

						break;

					case 'PingNotification':
						console.log("Received Ping Notification!");
						break;

					// case 'ClaimSubmissionNotification':
					// 	var claimId = newNotificationModel.attr('ClaimId');
					// 	//Confirm this with higher ups.
					// 	if(can.route.attr('page') === 'claims') { 
					// 		Claim.findOne({ id: claimId });
					// 	} 
					// 	else  if (can.route.attr('page') === 'claim' && can.route.attr('id') !== claimId) {
							
					// 		can.route.attr({
					// 			page: 'claim',
					// 			id: claimId
					// 		}, true);

					// 	}

					// 	break;
				}
			};
			
			$connection.hub.start()
				.then(function() {					
					// TODO Show only read and unread
					return Notification.getAll();
				})
				.then(function(n) {
					scope.attr('Notifications').replace(n);
				});
		},
		
		'.dismiss-all click': function(el, ev) {
			//Empty the array
			this.scope.attr('Notifications', []);
			$connection.notificationHub.server.deleteAll();
			ev.stopPropagation();
		},
		
		'.mark-all-read click': function(el, ev) {
			//Mark the notifications as read
			this.scope.attr('Notifications').forEach(function(notification){
				notification.attr('State', 1);
			});
			$connection.notificationHub.server.readAll();
			ev.stopPropagation();
		},
		
		'.noti click': function(el, ev) {
			// get notification, mark as read
			var noti = this.scope.attr('Notifications').findById(el.data('nid'))//.markRead();
			
			switch(noti.attr('_Type')) {
				case 'ClaimSubmissionNotification':
					if(noti._isErrored()){
						App.loadModal('modals/claim/SubmissionFailedModal', noti);
					}
					else {
						can.route.attr({
							page: 'claim',
							id: noti.attr('ClaimId')
						}, true);
					}
					break;
				case 'EligibilityNotification':
					App.loadModal('modals/eligibility/EligibilityModal', {
						id: el.data('eid')
					});
					break;
				case 'DdeCheckNotification':
					break;
			}
			
			noti.markRead();
		},

		'.dismiss click': function(el, ev) {
			var id = el.data('nid');
			var notifications = this.scope.attr('Notifications');
			//Delete the notification
			for(var i = 0; i < notifications.length; i++){
				if(notifications[i].NotificationId === id){
					notifications.splice(i, 1);
					break;
				}
			}
			$connection.notificationHub.server.delete(id);
			ev.stopPropagation();
		}
		
		/*
				getAll
		        getDismised
		        getRead
		        getUnread
		        getUserId
		        markDismissed(notificationBase)
		        markRead(notificationBase)
		        markUnread(notificationBase)
		*/	
	});

});
